<template>
  <div>
    <!-- <v-toolbar flat color="white" class="pt-3">
      <h2
        class="heading px-2 py-2"
      >{{contactInfo.name}} {{contactInfo.surname}}</h2>
    </v-toolbar> -->
    <v-layout justify-center align-top wrap v-if="contactInfo" mt-3>
      <v-flex xs4>
        <v-card class="rounded-card pt-3" color="white">
          <h3>Account Details</h3>
          <!-- <v-btn v-if="editInfoOption" @click="editItem(contactInfo)">Edit</v-btn> -->
          <v-card-text>
            <v-layout justify-left align-center wrap>
              <v-flex xs4 mx-1>
                <h3 class="grey--text text-xs-left">First Name:</h3>
              </v-flex>
              <v-flex xs4 mx-1>
                <h3 class="grey--text font-weight-light text-xs-left">{{contactInfo.name}}</h3>
              </v-flex>
             <v-flex xs4 mx-1>
                <h3 class="grey--text text-xs-left">Surname:</h3>
              </v-flex>
               <v-flex xs4 mx-1>
                <h3 class="grey--text font-weight-light text-xs-left">{{contactInfo.surname}}</h3>
              </v-flex>
              <v-flex xs4 mx-1 v-if="contactInfo.idNumber">
                <h3 class="grey--text text-xs-left">ID Number:</h3>
              </v-flex>
               <v-flex xs4 mx-1 v-if="contactInfo.idNumber">
                <h3 class="grey--text font-weight-light text-xs-left">{{contactInfo.idNumber}}</h3>
              </v-flex>
               <v-flex xs4 mx-1 v-if="contactInfo.mobileNumber">
                <h3 class="grey--text text-xs-left">Mobile No:</h3>
              </v-flex>
               <v-flex xs4 mx-1 v-if="contactInfo.mobileNumber">
                <h3 class="grey--text font-weight-light text-xs-left">{{contactInfo.mobileNumber}}</h3>
              </v-flex>
               <v-flex xs4 mx-1 v-if="contactInfo.emailAddress">
                <h3 class="grey--text text-xs-left">Email Address:</h3>
              </v-flex>
               <v-flex xs4 mx-1 v-if="contactInfo.emailAddress">
                <h3 class="grey--text font-weight-light text-xs-left">{{contactInfo.emailAddress}}</h3>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs4 >
        <v-card class="rounded-card pt-3" color="white">
          <h3>Registered Locations</h3>
          <v-card-text>
            <v-flex xs12 ma-3
              v-for="location in locations"
              :key="location.id"
            >
            <v-card flat hover color="white" @click="routerLinkToDetails(location)">
              <v-layout justify-left align-center wrap>
                <v-flex xs8>
                  <span class="grey--text">
                    {{location.locationDescription}}
                  </span>
                </v-flex>
                <v-flex xs4>
                  <span class="grey--text">
                    {{location.locationNetwork.name}}
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <documentcomponent
          :key="key"
          :contactid="this.$route.params.contactId"
          :documents="contactDocuments"
          @documentChange="fetchDocuments"
        ></documentcomponent>
      </v-flex>
    </v-layout>

    <!--
    <v-dialog persistent v-model="editContactDialog" width="750px">
      <v-card>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Login Settings</h3>
              </v-flex>
              <v-flex xs12 sm3 md6>
                <v-text-field
                  v-model="editedContactItem.emailAddress"
                  label="*Email Address"
                  type="email"
                  prepend-icon="email"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  id="editPasswordId"
                  v-model="editedContactItem.password"
                  label="Reset Password"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  @click:append="show1 = !show1"
                  ref="password"
                  v-on:blur="checkPassword"
                ></v-text-field>
                <span
                  v-if="displayPasswordError == true"
                  class="passWordError"
                >The password must contain atleast 8 characters consisting of atleast 1 uppercase letter, atleast 1 lowercase letter and atleast 1 number.</span>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-btn
                  id="resetPasswordButtonId"
                  @click="resetPassword"
                  flat color='primary'
                >Reset</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn @click="closeEditContact" color="primary" round>Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    -->

  </div>
</template>

<script>
import Api from "@/services/Api";
import Tags from "@/components/Tags.vue";
import DocumentCard from "@/components/DocumentCard.vue";

export default {
  props: ["contactsummary", "totalitems"],
  components: {
    tagscomponent: Tags,
    documentcomponent: DocumentCard
  },
  data() {
    return {
      tags: [],
      locations: [],
      contactInfo: [],
      contactDocuments: [],
      associateDialog: false,
      name: "",
      isLoading: true,
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      newDialog: false,
      key: 0,
      pagination: {},
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      activeTabName: "",
      tabs: [
        { name: "tags", displayName: "Tags" },
        {
          name: "locationNetworksLocations",
          displayName: "Associated Locations"
        },
        { name: "contactdocuments", displayName: "Documents" }
      ],
      //
      // editedContactItem: {},
      // editContactDialog: false,
      // editInfoOption: false,
      // show1: false,
      // displayPasswordError: false,
      //
    };
  },
  watch: {
    "$route.params.contactId": {
      immediate: true,
      async handler(value) {
        if (typeof value !== "undefined") {
          if (value !== this.contactInfo.id) {
            let route = await this.$store.state.currentOrg.org.permissions.filter(
              function(el) {
                return el.url === "/contactSummary/:contactId";
              }
            );
            await this.$store.dispatch("setCurrentRoute", route[0]);
            if (this.authRead(this.$store.state.currentRoute)) {
              this.initialize();
            }
          }
        }
      }
    }
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(
      function(el) {
        return el.url === "/contactSummary/:contactId";
      }
    );
    if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  async mounted() {
    this.setActiveTabName("tags");
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  methods: {
    fetchDocuments() {
      Api()
        .get("/upload/byContact/" + this.$route.params.contactId)
        .then(response => {
          this.contactDocuments = response.data;
          this.key+=1
        });
    },
    fetchLocationsByContact() {
      Api()
        .get("/LocationContact/byContact/" + this.$route.params.contactId)
        .then(response => {
          this.locations = response.data.map(x=>x.location);
        });
    },
    getContactInfo() {
      Api()
        .get("/contacts/" + this.$route.params.contactId)
        .then(response => {
          this.contactInfo = response.data[0];
        });
        //
        // if(this.$store.state.user.id == '16170') {
        //   this.editInfoOption = true;
        // }
        //
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    routerLinkToDetails(item) {
    //   this.editedItem = Object.assign({}, item);
      this.$router.push({
        path:
          "/locationnetworks/" +
          item.locationNetworkId +
          "/" +
          item.id
      });
    },
    getServiceAccounts(){
      
    },

    initialize() {
      this.getContactInfo();
      this.fetchDocuments();
      this.fetchLocationsByContact();
      this.getServiceAccounts()
    },

    //
    // editItem(itemC) {
    //   if(this.$store.state.user.id == '16170') {
    //       this.editedContactItem = Object.assign({}, itemC);
    //       this.editContactDialog = true; 
    //   }
    // },
    // checkPassword() {
    //   let passReg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
    //   const match = passReg.test(this.editedContactItem.password)
    //   if(match) {
    //     this.displayPasswordError = false
    //   } else {
    //     this.displayPasswordError = true
    //   }
    // },
    // resetPassword(){
    //   confirm('Are you sure you want to reset this password?')&&
    //   Api().put("/contacts/resetPassword/" + this.editedContactItem.id, {
    //       password: this.editedContactItem.password,
    //       Password: this.editedContactItem.password,
    //       emailAddress: this.editedContactItem.emailAddress,
    //   }).then(response =>{
    //       this.editContactDialog = false
    //   })
    // },
    // closeEditContact() {
    //   this.editContactDialog = false;
    // }
    //
  }
};
</script>

<style>
.passWordError {
  color: red;  
}
</style>
